import Pagination from 'components/Pagination'
import React from 'react'
import TruckCard from 'components/TruckCard'
import pathFromUrl from 'utils/pathFromUrl'
import { usePagination } from 'url-pagination'

import { TrucksListPageQuery } from './types/query'

type Props = {
  trucks: NonNullable<TrucksListPageQuery['marketBySlug']>['trucks']
  pagination: ReturnType<typeof usePagination>
}

const TrucksList = ({ trucks, pagination }: Props) => {
  if (trucks.records.length === 0)
    return (
      <div className="h-full flex justify-center items-center text-3xl text-gray-300 tracking-wide">
        No trucks found
      </div>
    )

  return (
    <div>
      <div className="-mx-4 flex flex-wrap box-border">
        {trucks.records.map((truck) => (
          <div key={truck.id} className="md:w-1/2 w-full">
            <TruckCard
              foodTypes={truck.menus[0]?.foodTypes}
              image={truck.foodImage!.medium}
              name={truck.name}
              rating={truck.ratingInfo}
              truckPath={pathFromUrl(truck.scheduleUrl)}
            />
          </div>
        ))}
      </div>

      <div className="flex justify-center mt-2">
        <Pagination total={trucks.total} {...pagination} showEmpty={false} />
      </div>
    </div>
  )
}

export default TrucksList
